import { render, staticRenderFns } from "./ordersTable.vue?vue&type=template&id=1e599a06&"
import script from "./ordersTable.vue?vue&type=script&lang=js&"
export * from "./ordersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports